<template>
  <div class="content work_flow_wrap">
    <!-- 筛选区（SearchBar 组件，样式基准 productInformation；FOUR-2958：一行三条件，其余入"更多筛选"折叠） -->
    <search-bar
      v-model="query"
      :conditions="conditions"
      @search="search(1)"
      @reset="reset"
      @height-change="recalcLayout"
    >
      <template #timeRange>
        <!-- 区间含当天 23:59:59，走 slot 自管拆分（组件 startKey/endKey 拆的是纯日期） -->
        <el-date-picker
          size="mini"
          v-model="timeRange"
          type="daterange"
          class="ipt-sty"
          value-format="yyyy-MM-dd"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        ></el-date-picker>
      </template>
    </search-bar>

    <!-- 列表 -->
    <div class="back-color-fff content-main-box" ref="tableBox" :style="'height:' + contentMainHeight + 'px'">
      <el-table
        ref="table"
        :data="tableData"
        stripe
        border
        style="width: 100%"
        v-loading="tableLoading"
        :height="tableHeight"
      >
        <el-table-column label="序号" width="50" header-align="center" align="center" fixed="left">
          <template slot-scope="scope">
            {{ (query.pageIndex - 1) * query.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="90"
        >
          <template slot-scope="scope">{{ scope.row.name || '-' }}</template>
        </el-table-column>
        <el-table-column
          label="身份"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="90"
        >
          <template slot-scope="scope">{{ identityName(scope.row.identity) }}</template>
        </el-table-column>
        <el-table-column
          prop="mobileNo"
          label="手机号"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="120"
        >
          <template slot-scope="scope">{{ scope.row.mobileNo || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="orgName"
          label="所在机构/院校"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="160"
        >
          <template slot-scope="scope">{{ scope.row.orgName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="deptName"
          label="所在科室/专业"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="120"
        >
          <template slot-scope="scope">{{ scope.row.deptName || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="labelExperience"
          label="标注经验"
          show-overflow-tooltip
          header-align="center"
          align="left"
          min-width="150"
        >
          <template slot-scope="scope">{{ scope.row.labelExperience || '-' }}</template>
        </el-table-column>
        <el-table-column
          prop="submitTime"
          label="提交时间"
          show-overflow-tooltip
          header-align="center"
          align="left"
          width="150"
        >
          <template slot-scope="scope">{{ formatTime(scope.row.submitTime) }}</template>
        </el-table-column>
        <el-table-column label="类型" header-align="center" align="center" width="90">
          <template slot-scope="scope">{{ ((scope.row.approveVO || {}).flowType) === '00104' ? '认证变更' : '认证审核' }}</template>
        </el-table-column>
        <el-table-column prop="approveState" label="审批状态" header-align="center" align="center" width="130">
          <template slot-scope="scope">
            <span :class="getStateShow((scope.row.approveVO || {}).approveState)">{{ approveStateText(scope.row) }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="170" fixed="right" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="toDetail(scope.row)">
              {{ (scope.row.approveVO || {}).approveState === 'A' ? '详情' : '查看' }}
            </a>
            <!-- 通过/驳回仅当前待审核人可见（workFlowCommon.getListBtnState） -->
            <a class="txt-color" v-if="getListBtnState('approval', scope.row) === 'approval'" @click="openAuditDialog(scope.row, 'Y')">通过</a>
            <a class="txt-color danger" v-if="getListBtnState('approval', scope.row) === 'approval'" @click="openAuditDialog(scope.row, 'R')">驳回</a>
            <!-- FOUR-2984：撤销/驳回/废弃留档行按后端 canDelete 显示删除入口（驳回及留档行仅创建人） -->
            <a class="txt-color danger" v-if="canDeleteRow(scope.row)" @click="onDelete(scope.row)">删除</a>
          </template>
        </el-table-column>
      </el-table>

      <!-- FOUR-2958③：分页入内容盒（弃用 fixed 底条），随盒居中 -->
      <el-pagination
        ref="pager"
        class="pt pb back-color-fff"
        background
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 50, 100]"
        :current-page="query.pageIndex"
        :page-size="query.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      >
      </el-pagination>
    </div>

    <!-- 通过/驳回弹窗 -->
    <el-dialog :title="auditAction === 'Y' ? '通过流程' : '驳回流程'" :visible.sync="auditDialogVisible" width="30%" top="15%">
      <el-input
        v-model="approveSuggest"
        type="textarea"
        :rows="5"
        maxlength="100"
        :placeholder="auditAction === 'Y' ? '输入通过备注（非必填）' : '输入驳回理由（必填）'"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="auditDialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" @click="submitAudit" :loading="submitting">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import workFlowCommon from '@/uilt/workFlowCommon';
import SearchBar from "@/components/SearchBar";
import { isCertResultQuery } from "@/uilt/certResultMessage";

export default {
  name: "certAuditManage",
  components: { SearchBar },
  data() {
    return {
      identityOptions: [],
      // 首行 3 条件，其余入"更多筛选"折叠行（FOUR-2958⑥）
      conditions: [
        { key: "name", label: "姓名", type: "input" },
        { key: "identity", label: "身份", type: "select", options: [], optLabel: "text", props: { filterable: true } },
        { key: "orgName", label: "所在机构/院校", type: "input" },
        { key: "approveState", label: "审批状态", type: "select", options: [], more: true, props: { filterable: true } },
        { key: "timeRange", label: "提交时间", type: "slot", more: true },
      ],
      approveStateOptions: [
        { value: "A", label: "审批中" },
        { value: "Y", label: "已通过" },
        { value: "R", label: "已驳回" },
        { value: "C", label: "已撤销" },
        // 每条申请一条记录（FOUR-2978）：重提后原申请行置已废弃留档，列表可选看
        { value: "D", label: "已废弃" },
      ],
      timeRange: [],
      // 引导估值：el-table 以 0 起步再在 mounted 里改值会丢高度更新（表格压成 0），先给非 0 初值，挂载后 recalcLayout 实测校正
      tableHeight: window.innerHeight - 320,
      contentMainHeight: window.innerHeight - 250,
      query: {
        name: "",
        identity: "",
        orgName: "",
        approveState: "",
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: 10,
        // 网关 X-USERINFO 不含租户字段，后端依赖前端显式传当前公司
        tenantGuid: localStorage.guid || "",
      },
      tableData: [],
      total: 0,
      tableLoading: false,
      auditDialogVisible: false,
      auditAction: "Y",
      approveSuggest: "",
      currentRow: null,
      submitting: false,
    };
  },
  mounted() {
    this.recalcLayout();
    window.addEventListener("resize", this.recalcLayout);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.recalcLayout);
  },
  created() {
    const query = this.$route.query;
    if (isCertResultQuery(query) && /^[0-9a-f]{32}$/i.test(query.bizGuid)) {
      const target = { path: '/certAuditManageDetail', query: { ...query } };
      if (this.$route.hash) target.hash = this.$route.hash;
      this.$router.replace(target);
      return;
    }
    this.identityOptions = this.getCodeListByKey("认证身份");
    if (!this.identityOptions.length) {
      // 兜底：字典未配置时按约定值展示
      this.identityOptions = [
        { value: "1", text: "医生" },
        { value: "2", text: "护士" },
        { value: "3", text: "药师" },
        { value: "4", text: "技师" },
        { value: "5", text: "医学生" },
        { value: "6", text: "其他" },
      ];
    }
    // SearchBar 条件引用同一份选项数组（created 时已就绪）
    this.conditions[1].options = this.identityOptions;
    this.conditions[3].options = this.approveStateOptions;
    this.search();
  },
  methods: {
    // 高度锚点实测：以内容盒顶部为锚，免去 header/条件行等魔法数；底部留 8px；取整避免小数像素
    recalcLayout() {
      if (!this.$refs.tableBox) return;
      const top = this.$refs.tableBox.getBoundingClientRect().top;
      this.contentMainHeight = Math.floor(window.innerHeight - top - 8);
      this.tableHeight = Math.floor(this.contentMainHeight - this.$refs.pager.$el.offsetHeight - 2);
      // 兜底：el-table 的 height watcher 有首帧丢更新场景（prop 已变而内部 layout 不动），nextTick 强制重设一次，已一致时幂等
      this.$nextTick(() => {
        if (this.$refs.table) this.$refs.table.layout.setHeight(this.tableHeight);
      });
    },
    // 撤销记录仅提交人显示删除，废弃留档行及其他状态继续使用原有权限判断。
    canDeleteRow(row) {
      const showState = (row.approveVO || {}).approveState;
      const isCanceled = row.bizApproveState !== "D" && (row.bizApproveState === "C" || showState === "C");
      if (!isCanceled && typeof row.canDelete === "boolean") return row.canDelete;
      if (row.bizApproveState === "D" || row.canDelete === false) return false;
      if (isCanceled || showState === "R") {
        let userinfo = {};
        try {
          userinfo = JSON.parse(localStorage.userInfo || "{}") || {};
        } catch (e) {
          userinfo = {};
        }
        const submitStaffGuid = (row.approveVO || {}).staffGuid;
        return !!(userinfo.staffGuid && userinfo.staffGuid === submitStaffGuid);
      }
      return false;
    },
    getStateShow(approvalState) {
      return workFlowCommon.getStateClass(approvalState);
    },
    // 操作按钮显隐（审批中且当前登录人是待审核人才展示通过/驳回）；入参取嵌套 approveVO
    getListBtnState(btnType, row) {
      let userinfo = {};
      try {
        userinfo = JSON.parse(localStorage.userInfo || "{}");
      } catch (e) {
        userinfo = {};
      }
      const vo = row.approveVO || {};
      return workFlowCommon.getListBtnState(
        btnType,
        vo.approveState,
        vo.staffGuid,
        vo.approveStaffGuids,
        userinfo.staffGuid,
        row.bizApproveState
      );
    },
    identityName(value) {
      const hit = this.identityOptions.find((item) => item.value === value);
      return hit ? hit.text : value || "-";
    },
    // 审批状态文案：读嵌套 approveVO.approveState（废弃行后端已还原为废弃前终态，与主流流程模块一致不在文案上加废弃标记；
    // bizApproveState=D 仅用于删除入口排除等按钮逻辑；接口降级行 approveState 仍为 D 显示"已废弃"）
    approveStateText(row) {
      const vo = row.approveVO || {};
      const stateMap = { N: "草稿中", A: "审批中", Y: "已通过", R: "已驳回", C: "已撤销", D: "已废弃" };
      return stateMap[vo.approveState] || vo.approveState || "-";
    },
    formatTime(time) {
      return time ? this.$moment(time).format("YYYY-MM-DD HH:mm:ss") : "-";
    },
    search(page) {
      if (page) {
        this.query.pageIndex = page;
      }
      // 提交时间区间（结束日含当天 23:59:59）
      this.query.startTime = this.timeRange && this.timeRange.length ? this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm:ss') : "";
      this.query.endTime = this.timeRange && this.timeRange.length ? this.$moment(this.timeRange[1]).format('YYYY-MM-DD 23:59:59') : "";
      this.tableLoading = true;
      this.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-cert/audit-list`, this.query)
        .then((res) => {
          this.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.tableData = res.data.data.records || [];
            // 分页总数字段为 totalRows（FOUR-2958④：读 total 恒 undefined 兜底 0 致"共 0 条"）
            this.total = res.data.data.totalRows || res.data.data.total || 0;
          }
        })
        .catch(() => {
          this.tableLoading = false;
        });
    },
    reset() {
      this.timeRange = [];
      this.query = {
        name: "",
        identity: "",
        orgName: "",
        approveState: "",
        startTime: "",
        endTime: "",
        pageIndex: 1,
        pageSize: 10,
        tenantGuid: localStorage.guid || "",
      };
      this.search();
    },
    handleSizeChange(size) {
      this.query.pageSize = size;
      this.query.pageIndex = 1;
      this.search();
    },
    handleCurrentChange(page) {
      this.query.pageIndex = page;
      this.search();
    },
    toDetail(row) {
      this.$router.push({ path: "/certAuditManageDetail", query: { guid: row.guid } });
    },
    openAuditDialog(row, action) {
      this.currentRow = row;
      this.auditAction = action;
      this.approveSuggest = "";
      this.auditDialogVisible = true;
    },
    submitAudit() {
      if (this.auditAction === "R" && !this.approveSuggest.trim()) {
        this.$message.error("驳回时必须填写驳回原因");
        return;
      }
      const userinfo = JSON.parse(localStorage.userInfo || "{}");
      const url =
        this.auditAction === "Y"
          ? `/${serverConfig.msSalesPerformService}/work-flow/data/batch-allow-flow`
          : `/${serverConfig.msSalesPerformService}/work-flow/data/batch-backup-flow`;
      this.submitting = true;
      this.api
        .postJson(url, [
          {
            approveStaffGuid: userinfo.staffGuid,
            approveSuggest: this.approveSuggest,
            // 随单取真实流程类型（00103 首审/00104 变更）；接口侧目前不读此字段，取真实值防后续启用
            flowType: ((this.currentRow.approveVO || {}).flowType) || "00103",
            funcCode: "RZSHGL",
            // approveGuid=tr_approve 主键（tr_staff_cert.flow_no），审批动作入参
            guid: (this.currentRow.approveVO || {}).approveGuid,
          },
        ])
        .then((res) => {
          this.submitting = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success("操作成功");
            this.auditDialogVisible = false;
            this.search();
          } else {
            this.$message.error(res.data.msg || "操作失败");
          }
        })
        .catch(() => {
          this.submitting = false;
        });
    },
    onDelete(row) {
      this.$confirm("确定删除该条认证资料吗？删除后不可恢复。", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.api
          .postJson(`/${serverConfig.msPersonnelService}/staff-cert/delete/${row.guid}?tenantGuid=${localStorage.guid || ''}`)
          .then((res) => {
            if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
              this.$message.success("删除成功");
              this.search();
            } else {
              this.$message.error(res.data.msg || "删除失败");
            }
          });
      });
    },
  },
};
</script>

<style scoped>
.danger {
  color: #f56c6c;
}
/* 废弃行组合文案（如"已撤销(已废弃)"8字）超出标签宽会折行致"已废弃"视觉缺失：禁止折行，配合列宽130单行放下 */
.content /deep/ .approve-state {
  white-space: nowrap;
}
/* 操作列竖线分隔对齐渠道管理/联系人管理参考样式（FOUR-2958①复测）：紧凑间距、竖线浅灰可见 */
a.txt-color + a.txt-color {
  margin-left: 4px;
}
a.txt-color + a.txt-color::before {
  content: "|";
  display: inline-block;
  margin-right: 4px;
  color: #4fa1a4 !important;
}
</style>
